const Design = [
    {
      id: 1,
      name: "Atharva Admane",
      position: "Design Lead",
      image: "https://i.ibb.co/FY4Rs6g/profile-pic-22.png",
      alt: "Lead_Image",
      col: 4,
      linkedin: "https://www.linkedin.com/in/atharva-admane-012560201",
      instagram: "https://instagram.com/atharva.1426",
      github: "",
      link: "",
    },
    {
      id: 2,
      name: "Aditya Nimbalkar",
      position: "Design Member",
      image: "https://i.ibb.co/Tq4QkRT/aditya-nimbalkar.png",
      alt: "Member_Image",
      col: 4,
      linkedin: "https://www.linkedin.com/in/aditya-nimbalkar-professional/",
      instagram: "https://instagram.com/nottherealadi",
      github: "",
	  googleCloud: "https://www.cloudskillsboost.google/public_profiles/a74efe1e-6cdb-4b43-9713-1e98e57438b7",
      link: "",
    },
    {
      id: 3,
      name: "Sankalp Bhirud",
      position: "Design Member",
      image: "https://i.ibb.co/mqkjvr8/profile-pic-23.png",
      alt: "Member_Image",
      col: 4,
      linkedin: "https://www.linkedin.com/in/sankalp-bhirud-557799250/",
      instagram: "https://instagram.com/sankalpbhirud",
      github: "",
      link: "",
    },
    {
      id: 4,
      name: "Neel Sawant",
      position: "Design Member",
      image: "https://i.ibb.co/q5pbymg/profile-pic-20.png",
      alt: "Member_Image",
      col: 5,
      linkedin: "https://www.linkedin.com/in/neel-sawant-a5a10a259",
      instagram: "https://instagram.com/neel_sawant.11",
      github: "https://github.com/Neels11",
      link: "",
    },
    {
      id: 5,
      name: "Aryan Kadam",
      position: "Design Member",
      image: "https://i.ibb.co/Rybrfsc/profile-pic-30.png",
      alt: "Member_Image",
      col: 5,
      linkedin: "https://www.linkedin.com/in/aryan-kadam-b883041ba",
      instagram: "https://instagram.com/rn_kadam_173",
      github: "https://github.com/RnKadam?tab=overview&from=2023-07-01&to=2023-07-31",
      link: "",
    }
  ];
  
  export default Design;
  